import { assign } from 'xstate';
import { Context } from '../bookingMachine';

const assignError = assign<Context, any>({
    error: (ctx, evt) => evt.data,
});

export default assignError;
